import {
  createRootRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
// import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { useEffect } from "react";
import { useAuthListener } from "@/features/auth";
import {
  trackPageView,
  saveAttributionData,
  enrichAttributionWithGeo,
} from "@/features/analytics";
import { getEffectiveParams } from "@/features/config";
import { hasTrackingConsent } from "@/features/consent/consent";
import { maybeRedirectToNativeBrowser } from "@/shared/lib/native-browser";
import { CookieConsent } from "@/features/consent/cookie-consent";

function RootLayout() {
  useAuthListener();

  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    // May navigate away (Meta in-app webview → system browser) before anything else.
    maybeRedirectToNativeBrowser(getEffectiveParams());
    if (!hasTrackingConsent()) return;
    saveAttributionData();
    enrichAttributionWithGeo();
  }, []);

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return (
    <>
      <Outlet />
      <CookieConsent />
      {/* {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />} */}
    </>
  );
}

export const rootRoute = createRootRoute({
  component: RootLayout,
});
